import React from "react";

const PaperDarkBG = ({ children, className = "", fullHeight = false}) => {
  return (


    <div
      className={`${fullHeight ? "min-h-screen" : ""} w-full text-white ${className}`}
      style={{
        backgroundColor: "#0e1116",
        backgroundImage: `
          radial-gradient(rgba(172,142,103,1) 1px, transparent 1px),
          radial-gradient(rgba(172,142,103,1) 1px, transparent 1px),
          radial-gradient(rgba(172,142,103,255,0.03) 1px, transparent 1px),
          linear-gradient(rgba(255,255,255,0.015) 1px, transparent 1px)
        `,
        backgroundSize: "30px 30px 3ßpx, 20px 20px, 100% 10px",
        backgroundPosition: "0 0, 10px 10px, 0 0",
       
       
      }}
    >
      {children}
    </div>
   
  );
};

export default PaperDarkBG;
